import { Route } from 'react-router-dom';
import { Navigate } from 'react-router';
import { Layout } from 'components/layout';
import FacebookPage from '../pages/facebook';
import TikTokPage from '../pages/tiktok';

const ServicesRouter = (
  <Route path="/services">
    <Route index element={<Navigate to="facebook" />} />
    <Route
      path="facebook"
      element={
        <Layout title="Facebook Ads Automation">
          <FacebookPage />
        </Layout>
      }
    />
    <Route
      path="tiktok"
      element={
        <Layout title="TikTok Ads Automation">
          <TikTokPage />
        </Layout>
      }
    />
    <Route path="*" element={<Navigate to="/facebook" />} />
  </Route>
);

export default ServicesRouter;